import React, { createContext, useState, useEffect } from 'react';

export const AppModeContext = createContext();

export const AppModeProvider = ({ children }) => {
  const [appMode, setAppMode] = useState(() => {
    return localStorage.getItem('appMode') || 'clinic';
  });

  useEffect(() => {
    localStorage.setItem('appMode', appMode);
  }, [appMode]);

  const toggleMode = (mode) => {
    setAppMode(mode);
  };

  return (
    <AppModeContext.Provider value={{ appMode, toggleMode }}>
      {children}
    </AppModeContext.Provider>
  );
};
